import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AgenciesService } from './api/agencies.service';
import { BookingService } from './api/booking.service';
import { CustomersService } from './api/customers.service';
import { DebugService } from './api/debug.service';
import { ReportService } from './api/report.service';
import { SettingsService } from './api/settings.service';
import { UsersService } from './api/users.service';
import { VehiclesService } from './api/vehicles.service';
import { InvoiceService } from './api/invoice.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AgenciesService,
    BookingService,
    CustomersService,
    DebugService,
    ReportService,
    SettingsService,
    UsersService,
    VehiclesService,
    InvoiceService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
